import { MappedRouteProvider } from "@/router/workItemRouteProvider";
import routeMap from "@/router/workItemRouteMap";

const mixin = {
    created() {
        this.workItemRoutes = new MappedRouteProvider(routeMap);
    }
}

export default mixin